import { AddAPhoto } from "@material-ui/icons";
import { Image, Upload, message } from "antd";
import { IMAGE_UPLOADER_STORAGE } from "constants/ApiConstant";
import { strings } from "res";
import React from "react";

const ImageUploader = ({ onChange, imageUrl }) => {
  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <AddAPhoto />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const fileTypesImage = ["image/jpeg", "image/png", "image/jpg"];

  const beforeUpload = (file) => {
    const isValidType = fileTypesImage.includes(file.type);
    if (!isValidType) {
      message.error("You can only upload video files (MP4, MPEG, MOV, AVI)!");
      return false;
    }

    const isLt20M = file.size / 1024 / 1024 < 20;
    if (!isLt20M) {
      message.error("Image must smaller than 20MB!");
      return false;
    }

    message.success("Image successfully uploaded!");
    return true;
  };

  return (
    <>
      <Upload
        name="file"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}

        action={strings.api.upload_api}
        onChange={onChange}
        beforeUpload={beforeUpload}
      >
        {imageUrl ? (
          <Image
            preview={true}
            src={imageUrl}
            alt="avatar"
            style={{ width: "100%" }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
      <p>max file size: 20MB</p>
    </>
  );
};

export default ImageUploader;
